import JSZip from 'jszip/dist/jszip';

export default function createZip() {
    return new JSZip();
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-ooxml/dist/es/utils/create-zip.js
// module id = ../../../../@progress/kendo-ooxml/dist/es/utils/create-zip.js
// module chunks = vendor